module.exports = __webpack_public_path__ + "img/back8.d32861ec.png";